<!-- 商品分类 -->
<template>
    <div class="page_content">
        <!-- <subComponents ref="showSelectData"></subComponents> -->
        <el-dialog :visible.sync="showStatus" :title="actionData.cate === 0 ? '新增分类' : '编辑分类'" width="50%"
            :modal-append-to-body="true" :append-to-body="true" :close-on-click-modal="false"
            :close-on-press-escape="true" center>
            <goodsCategoryModal v-if="showStatus" ref="goodsCategoryMastRef" @drawerCancel="drawerCancel"
                @toDetail="toDetail" :actionData="actionData"></goodsCategoryModal>
        </el-dialog>

        <div style="display: flex; just-content: space-between">
            <div class="page_content_center" style="width: 30%">
                <div class="page_content_top">
                    <v-button :buttonList="buttonList" @actionSet="actionSet" :buttonFlag="false"
                        @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
                    <div class="page_content_top_line">
                        <v-search :searchList="searchList" :getRequestData="getRequestData" @searchData="searchData"
                            @openSearch="openSearch"></v-search>
                    </div>
                </div>
                <el-table :key="tableFlag" stripe @selection-change="handleSelectionChange" @row-click="storePriceClick"
                    :data="returnData.list" :height="tableHeight" border style="width: 100%" highlight-current-row
                    size="mini">
                    <!-- 主信息 -->

                    <el-table-column header-align='center' label="选择操作" width="80">
                        <template slot-scope="scope">
                            <el-radio v-model="selectedRowIndex" :label="scope.$index" border size="mini"
                                @change="handleRadioChange(scope.row, scope.$index)">
                                <i class="el-icon-thumb"></i>
                            </el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column v-for="(tableValye, tableKey) in pageShowData" :key="tableKey" align="center"
                        :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip
                        :min-width="tableValye.fieldWeight" :fixed="tableValye.fixed || false">
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'startTime'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>


                            <span v-else-if="tableValye.entityField == 'startTime'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>

                            <span v-else-if="tableValye.entityField == 'endTime'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.entityField == 'conType'">
                                {{ Number(scope.row.conType) === 1 ? "按商品" : "按品系" }}
                            </span>
                            <span v-else-if="tableValye.entityField == 'resType'">
                                {{ Number(scope.row.resType) === 1 ? "赠送商品" : Number(scope.row.resType) === 2 ? "整单减金额"
                                    :
                                    "促销条件商品打折" }}
                            </span>
                            <span v-else-if="tableValye.entityField == 'roundType'">
                                {{ Number(scope.row.roundType) === 0 ? "全部" : Number(scope.row.roundType) === 1 ? "周" :
                                    "日" }}
                            </span>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                    scope.row[tableValye.entityField]
                                }}</a>
                            </span>


                            <el-input clearable style="width: 90px; margin: 0 1px"
                                @blur="blur(scope.$index, tableValye.entityField)"
                                v-else-if="tableValye.fieldType == 'input'" type="number"
                                v-model="scope.row[tableValye.entityField]"></el-input>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page_content_bottom">
                    <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
                        @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
                </div>
            </div>
            <div style="width: 70%">
                <div class="page_content_top">
                    <v-button :buttonList="buttonList2" @actionSet="actionSet2" :buttonFlag="false"
                        @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
                    <div class="page_content_top_line">
                        <v-search :searchList="searchList2" :getRequestData="getRequestData2" @searchData="searchData2"
                            @openSearch="openSearch"></v-search>
                    </div>
                </div>

                <el-table class="mainTable xunjia" ref="mxTable" :data="returnData2.list" :height="tableHeight"
                    @row-click="storePriceClick2" :key="$store.state.tableNum" border style="width: 100%"
                    highlight-current-row size="mini">
                    <el-table-column align="center" label="分类明细列表">
                        <el-table-column header-align='center' label="选择操作" width="80">
                            <template slot-scope="scope">
                                <el-radio v-model="selectedRowIndex2" :label="scope.$index" border size="mini"
                                    @change="handleRadioChange2(scope.row, scope.$index)">
                                    <i class="el-icon-thumb"></i>
                                </el-radio>
                            </template>
                        </el-table-column>
                        <el-table-column v-for="(tableValye, tableKey) in pageShowPeopleData" :key="tableKey"
                            align="center" :prop="tableValye.entityField" :label="tableValye.showField"
                            show-overflow-tooltip :min-width="tableValye.fieldWeight"
                            :fixed="tableValye.fixed || false">
                            <template slot-scope="scope">

                                <span v-if="tableValye.entityField == 'goodType'">
                                    {{ Number(scope.row.goodType) === 0 ? "药品" : "器械" }}
                                </span>
                                <span v-else>{{ scope.row[tableValye.entityField] }}</span>
                            </template>

                        </el-table-column>
                    </el-table-column>
                    <!-- <el-table-column label="操作" align="center" min-width="80px">
                   <template slot-scope="scope">
                      <el-button type="danger" size="mini" @click="delDetail(scope.$index)">删除</el-button>
                   </template>
                </el-table-column> -->
                </el-table>
                <div class="page_content_bottom">
                    <v-pagination :page="getRequestData2.page" :rows="getRequestData2.rows" :total="returnData2.total"
                        @setDataPageSize="setDataPageSize2" @setDataPageNumber="setDataPageNumber2"></v-pagination>
                </div>
            </div>
        </div>

        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth"
                @sendTitle="getSearchName" :parentSearchData="parentSearchData" />
        </el-dialog>

        <!-- 通用名称列表 -->
        <el-dialog :title="actionData.cate === 0 ? '新增分类明细' : '编辑分类明细'" v-if="storeVisible" :visible.sync="storeVisible"
            width="80%" center>
            <div class="store-modal-content">
                <!-- 搜索条件 -->
                <div class="search-container" style="margin-bottom: 20px;">
                    <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                        <el-form-item label="商品名称">
                            <el-input v-model="searchForm.bgmName" placeholder="请输入商品名称"></el-input>
                        </el-form-item>
                        <el-form-item label="生产商">
                            <el-input v-model="searchForm.manufacturer" placeholder="请输入生产商"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="searchCommonNames">查询</el-button>
                            <el-button @click="resetSearch">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>

                <!-- 表格 -->
                <el-table :data="commonNamesList" border style="width: 100%" height="400"
                    @selection-change="handleCommonNameSelectionChange" @row-click="handleRowClick" ref="commonNamesTable">
                    <el-table-column type="selection" width="55">
                    </el-table-column>
                    <el-table-column prop="bgmCode" label="商品编码" min-width="120">
                    </el-table-column>
                    <el-table-column prop="bgmName" label="通用名称" min-width="180">
                    </el-table-column>
                    <el-table-column prop="manufacturer" label="生产商" min-width="180">
                    </el-table-column>
                    <el-table-column prop="placeorigin" label="产地" min-width="120">
                    </el-table-column>
                    <el-table-column prop="retailPrice" label="统一零售价" min-width="60">
                        <template slot-scope="scope">
                            {{ scope.row.retailPrice ? '¥' + scope.row.retailPrice : '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="spec" label="规格" min-width="180">
                    </el-table-column>
                </el-table>

                <!-- 分页 -->
                <div class="pagination-container" style="margin-top: 20px; text-align: right;">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[30, 50, 100,200]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="storeVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitCommonNameSelection">确 定</el-button>
            </div>
        </el-dialog>


        <customDesign ref="customDesign"></customDesign>


    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import SearchScheme from "../../../byComponents/SearchScheme.vue"
import goodsCategoryModal from "./goodsCategoryModal.vue"
import { nameList, storeList, searchList, searchList2 } from "./goodsCategory.js"

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        goodsCategoryModal
    },
    data() {
        //这里存放数据
        return {
            sField: "",
            exTitle: "",
            exWidth: "",
            searchList: searchList,
            searchList2: searchList2,
            getRequestData: {
                businessId: "",
                creater: 0,
                ormId: 0,
                page: 1,
                rows: 30,
                start: "",
                end: "",
                btName: "",
            },
            getRequestData2: {
                businessId: "",
                bgmName: "",
                btId: "",
                // creater: 0,
                end: "",
                ormId: 0,
                page: 1,
                rows: 30,
                start: "",
            },
            //---------------
            seTitle: "",
            DialogVisible: false,
            seId: "",
            setField: "",
            setType: "",
            seWidth: "0",
            parentSearchData: {},
            //---------------
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            returnData2: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],
            buttonList2: [
                { actionType: 0, jurName: '新增', icon: 'el-icon-plus' },
                // { actionType: 1, jurName: '修改', icon: 'el-icon-edit' },
                { actionType: 2, jurName: '删除', icon: 'el-icon-delete' }
            ],
            multipleSelection: [],
            pageShowData: {},
            pageShowPeopleData: {},
            tableFlag: 0,
            selectedDataIndex: 0,
            btIds: "",
            goodPriceIds: "",

            tableHeight: 0,
            showStatus: false,
            actionData: {},
            storeVisible: false,
            storeList: [],
            loading: false,
            searchPersonName: "",
            selectedRowIndex: null,
            selectedRowIndex2: null,
            priceGroupForm: {
                // bgmName: '',
                // goodType: '', 
                // groupName: '',
                salesPrice: '',
                memberPrice: '',
                // manufacturer: '',
                // spec: '',
                // placeorigin: '',
                bgmId: ''
            },
            showRateDialog: false, // 控制折扣率弹窗显示
            rate: '',              // 会员价折扣率
            rateForm: {
                rate: ''
            },
            searchForm: {
                bgmName: '',
                manufacturer: ''
            },
            commonNamesList: [],
            currentPage: 1,
            pageSize: 30,
            total: 0
        }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.smName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.pspmBuycus = ""
                }
            },
            deep: true,
        },


    },
    //方法集合
    methods: {
        // 子组件触发
        drawerCancel(e) {
            console.log(e, "+++++++++")
            this.showStatus = false
            // this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
            this.getPageInfo()
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)

            this.$refs["customDesign"].openBox(
                pathInfo.jurId,
                this.pageShowData,
                pathInfo.jurName
            )
        },
        storePriceClick(row) {
            this.btIds = row.btId
            this.selectedRowIndex = this.returnData.list.findIndex(item => item.btId === row.btId)
            this.getDataStoreList()
        },
        storePriceClick2(row) {
            this.goodPriceIds = row.id
            console.log(row, 'row');
            this.selectedRowIndex2 = this.returnData2.list.findIndex(item => item.id === row.id)

        },
        // 检索Id, 索引(表格中), 标识
        openSearch(val) {
            this.setType = val.type
            this.seId = val.sId
            this.setField = val.sField
            this.parentSearchData[this.setType] = this.getRequestData[this.setType]
            if (this.setType == 'bgmName') {
                this.parentSearchData.bgmId = this.getRequestData2.bgmId


            }
            this.DialogVisible = true

        },

        // 赋值字段
        paramValue(val) {
            let arr = this.setField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        //检索方案返回的数据
        changeInputModel(val) {
            if (val) {
                if (this.setType == 'salesName') {
                    this.getRequestData.salesName = val.opmName
                    this.getRequestData.salesId = val.opmId
                } else {
                    this.paramValue(val)
                }
            }
            this.DialogVisible = false
        },
        // 勾选明细
        handleSelectionChange(val) {
            console.log(val, "+++++++++")
            this.multipleSelection = val
        },
        getSeWidth(e) {
            console.log(e)
            this.seWidth = e + "%"
        },
        getWidth(e) {
            console.log(e)
            this.exWidth = e + "%"
        },
        getSearchName(e) {
            console.log(e)
            this.seTitle = e
        },
        // 获取数据列表
        async getPageInfo() {
            this.pageShowData = JSON.parse(JSON.stringify(nameList))
            this.pageShowPeopleData = JSON.parse(JSON.stringify(storeList))

            let res = await this.$http.getTypeList(this.getRequestData)
            if (res.status == 200) {
                this.returnData.list = res.result.list
                this.returnData.total = res.result.total
                this.returnData.pageNum = res.result.pageNum
                this.returnData.pages = res.result.pages
                this.selectedDataIndex = 0
                if (this.returnData.list.length > 0) {
                    this.btIds = this.returnData.list[0].btId
                    this.getDataStoreList()
                    this.$nextTick(() => {
                        this.selectedRowIndex = 0
                        this.multipleSelection = [this.returnData.list[0]]
                    })
                } else {
                    this.returnData2.list = []
                }
            } else {
                this.$message({
                    message: res.message,
                    type: "error",
                })
            }

        },
        // 获取表单配置
        async getFormData() {
            try {
                var pathId = parent.getMenuInfo(this.$route.path);
                let responseData = await this.$http.getJur({
                    ids: [pathId.jurId]
                });
                if (responseData.status == 200) {
                    this.formDataList = responseData.result.jurFormVoList || [];
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            } catch (error) {
                console.error("获取表单配置失败:", error);
                this.$message({
                    message: "获取表单配置失败",
                    type: "error",
                });
            }
        },
        // 动作集合
        async actionSet(actionData) {
            console.log(actionData.actionType)
            switch (actionData.actionType) {
                case 0:
                    this.showStatus = true
                    this.actionData = {
                        cate: 0,
                        formData: [],
                        oldData: "",
                    }
                    break
                case 1:
                    if (this.selectedRowIndex === null || this.selectedRowIndex < 0) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        })
                        return false
                    }
                    this.showStatus = true
                    this.actionData = {
                        cate: 1,
                        formData: [],
                        oldData: this.returnData.list[this.selectedRowIndex],
                    }
                    break
                case 2:
                    this.delDataAction()
                    break

                case 4:
                    this.initDataAction()
                    break

            }
        },
        actionSet2(actionData) {
            console.log(actionData.actionType, 'actionData.actionType')
            switch (actionData.actionType) {
                case 0:
                    this.searchCommonNames()
                    this.storeVisible = true
                    this.actionData = {
                        cate: 0,
                        formData: [],
                        oldData: "",
                    }
                    break
                case 1:
                    if (this.selectedRowIndex2 === null || this.selectedRowIndex2 < 0) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        })
                        return false
                    }

                    this.storeVisible = true
                    this.priceGroupForm = this.returnData2.list[this.selectedRowIndex2]
                    break
                case 2:
                    this.delDataAction2()
                    break
            }
        },


        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        searchData2() {
            this.getRequestData2.page = 1
            this.getDataStoreList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },
        setDataPageNumber2(val) {
            this.getRequestData2.page = val
            this.getDataStoreList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },
        setDataPageSize2(val) {
            this.getRequestData2.page = 1
            this.getRequestData2.rows = val
            this.getDataStoreList()
        },
        // 获取数据列表 方案
        async getDataList() {
            let responseData = await this.$http.getTypeList(this.getRequestData)
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list
                this.returnData.total = responseData.result.total
                this.returnData.pageNum = responseData.result.pageNum
                this.returnData.pages = responseData.result.pages
                this.selectedDataIndex = 0
                if (this.returnData.list.length > 0) {
                    this.btIds = this.returnData.list[0].btId
                    this.getDataStoreList()
                    this.$nextTick(() => {
                        this.selectedRowIndex = 0
                        this.multipleSelection = [this.returnData.list[0]]
                    })
                } else {
                    this.returnData2.list = []
                }
                this.$nextTick(() => {
                    this.tableHeight = this.$common.getTableHeight()
                    this.tableFlag++
                })
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                })
            }
        },

        // 查询当前门店绑定的人员 
        async getDataStoreList() {

            this.getRequestData2.btId = this.btIds
            let responseData = await this.$http.getDetailList(this.getRequestData2)
            if (responseData.status == 200) {
                this.returnData2.list = responseData.result.list
                this.returnData2.total = responseData.result.total
                this.returnData2.pageNum = responseData.result.pageNum
                this.returnData2.pages = responseData.result.pages
                this.selectedRowIndex2 = 0
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                })
            }
        },
        // 删除数据
        delDataAction() {
            if (this.selectedRowIndex === null || this.selectedRowIndex < 0) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                })
                return false
            }

            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [this.returnData.list[this.selectedRowIndex].btId],
                    }
                    let responseData = await this.$http.deraBgmTypeDelete(delData)
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        })

                        this.getDataList()
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        })
                    }
                })
                .catch(() => { })
        },
        // 初始化数据
        initDataAction() {
            if (this.selectedRowIndex === null || this.selectedRowIndex < 0) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                })
                return false
            }
            const row = this.returnData.list[this.selectedRowIndex];

            this.rateForm.rate = '';
            this.showRateDialog = true; // 打开输入折扣率弹窗
        },
        delDataAction2() {
            if (this.selectedRowIndex2 === null || this.selectedRowIndex2 < 0) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                })
                return false
            }
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [this.returnData2.list[this.selectedRowIndex2].id],
                    }
                    let responseData = await this.$http.deraBgmTypeDelDetail(delData)
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        })
                        this.getDataStoreList()
                        this.getDataList()
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        })
                    }
                })
                .catch(() => { })
        },
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
        },


        handleRadioChange(row, index) {
            this.selectedRowIndex = index;
            this.btIds = row.id;
            this.getDataStoreList();
        },
        handleRadioChange2(row, index) {
            this.selectedRowIndex2 = index;
            this.goodPriceIds = row.id;

        },
        searchCommonNames() {
            this.currentPage = 1;
            this.getDataCommonNames();
        },
        resetSearch() {
            this.searchForm.bgmName = '';
            this.searchForm.manufacturer = '';
            this.currentPage = 1;
            this.getDataCommonNames();
        },
        async getDataCommonNames() {
            let params = {
                businessId: "",
                bgmName: this.searchForm.bgmName,
                manufacturer: this.searchForm.manufacturer,
                page: this.currentPage,
                rows: this.pageSize,
                start: '',
                end: '',
                ormId: 0
            };
            let responseData = await this.$http.getBgmListByType(params);
            if (responseData.status == 200) {
                this.commonNamesList = responseData.result.list;
                this.total = responseData.result.total;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        handleCommonNameSelectionChange(val) {
            this.selectedCommonNames = val.map(item => item.bgmId);
        },
        handleRowClick(row) {
          this.$refs.commonNamesTable.toggleRowSelection(row);
        },
        submitCommonNameSelection() {
            // 提交数据
            this.$http.deraBgmTypeAddDetail({
                bgmIdList: this.selectedCommonNames,
                btId: this.btIds
            }).then(response => {
                if (response.status == 200) {
                    this.$message.success('保存成功');
                    this.storeVisible = false;
                    this.getDataStoreList();
                } else {
                    this.$message.error(response.message);
                }
            });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getDataCommonNames();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getDataCommonNames();
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo()
        this.getButtonList()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$nextTick(() => {
            this.tableHeight = this.$common.getTableHeight()
            this.tableFlag++
        })
    },
    updated() {
        this.$nextTick(() => {
            this.tableHeight = this.$common.getTableHeight()
        })
    }, //生命周期 - 更新之后

}
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.btns {
    display: flex;
    position: absolute;
    z-index: 999;
    padding-left: 10px;
    padding-top: 2px;
}

::v-deep.xunjia tr {
    height: 39px !important;
}

::v-deep.xunjia .el-button {
    font-size: 12px;
    padding: 5px 10px;
}

::v-deep.xunjia .el-button--danger {
    color: #fff;
    background-color: #f56c6c;
    border-color: #f56c6c;
}

::v-deep.xunjia .el-button--danger:hover {
    color: #fff;
    background-color: #f78989;
    border-color: #f78989;
}

::v-deep.xunjia .el-table__fixed-right {
    height: 100% !important;
    position: absolute;
    top: 0;
    overflow: hidden;
    background-color: #fff;
    z-index: 3;
}

::v-deep.xunjia .el-table__fixed-right-patch {
    background-color: #fff;
}
</style>